/**
 * Zzzing Admin API
 * Zzzing Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: ci@zzzing.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PropertyCalendarFilter { 
    /**
     * The properties to retrieve the calendar for
     */
    property_ids: Array<string>;
    /**
     * The start date of the entries to filter from the calendar
     */
    date_from: string;
    /**
     * The end date of the entries to filter from the calendar
     */
    date_to: string;
}

